import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CartState } from './cart.state';

export const selectCartState = createFeatureSelector<CartState>('cart');

export const selectCartDetails = createSelector(
  selectCartState,
  (state: CartState) => state.cartDetails,
);

export const selectCartCount = createSelector(
  selectCartState,
  (state: CartState) => state.cartCount,
);

export const selectCartStatus = createSelector(
  selectCartState,
  (state: CartState) => state.cartStatus,
);

export const selectCartItems = createSelector(
  selectCartState,
  (state: CartState) => state.cartItems,
);

export const selectSpinner = createSelector(
  selectCartState,
  (state: CartState) => state.spinner,
);

export const selectRefreshCart = createSelector(
  selectCartState,
  (state: CartState) => state.refreshCart,
);
